<template>
  <div class="solution section5">
    <div class="banner">
      <div class="w1200">
        <h3>农产品交易中心数字化解决方案</h3>
        <p>
          农产品交易中心打通产业链，将投入品和产出品交易实现线上化；
        </p>
        <p>
    对比传统线下交易模式，帮助种养殖户降本增收，以交易为核心，贯通连接仓储物流及金融服务，
    实现配套服务；网络化助力产业发展，成为政府推进乡村振兴的有力抓手。
        </p>
      </div>
    </div>
    <div class="container">
      <img src="@/assets/pc/images/solution5_01.jpg" alt />
      <img src="@/assets/pc/images/solution5_02.jpg" alt />
      <div class="mar30_t"></div>
      <img src="@/assets/pc/images/solution5_03.jpg" alt />
      <!-- <h3>农产品交易中心数字化交易平台</h3>
      <ul class="clear">
        <li v-for="n in 6" :key="n"></li>
      </ul>
      <div class="text-center">
        <em>精准化数据分析</em>
        <em>产业大数据沉淀</em>
      </div>
      <div class="button cursor">交易中心大数据平台</div> -->
      <div
        class="button"
        @click="
          showDialog = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <!-- <div class="d_footer">
      <h3>多方位服务交易中心</h3>
      <ul class="clear">
        <li>
          <div class="img"></div>
          <p>统一化会员管理体系</p>
        </li>
        <li>
          <div class="img"></div>
          <p>标准化商品管理体系</p>
        </li>
        <li>
          <div class="img"></div>
          <p>多模式统一交易交收规则</p>
        </li>
        <li>
          <div class="img"></div>
          <p>统一支付结算</p>
        </li>
        <li>
          <div class="img"></div>
          <p>标准化物流流通体系</p>
        </li>
        <li>
          <div class="img"></div>
          <p>全方位多维度风控监管体系</p>
        </li>
      </ul>
      <div
        class="button"
        @click="
          showDialog = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div> -->
    <dialog-box
      :showDialog="showDialog"
      :systemId="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>
<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      systemId: '3',
      showDialog: false,
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/pc/css/solution-5.scss';
</style>
